import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home.vue'
import Front from '../pages/Front.vue'
import Start from '../pages/Start.vue'
import FeedsPage from '../pages/FeedsPage.vue'
import Learn from '../pages/Learn.vue'
import Authentication from '../pages/Authentication.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'root',
            component: Front
        },
        {
            path: '/index.html',
            name: 'themes',
            component: Home
        },
        {
            path: '/start',
            name: 'start',
            component: Start
        },
        {
            path: '/front',
            name: 'front',
            component: Front
        },
        {
            path: '/theme',
            name: 'themes',
            component: Home,    
        },
        {
            path: '/theme/:theme',
            name: 'themes',
            component: Home,    
        },
        {
            path: '/theme/:theme/:task',
            name: 'themes',
            component: Home
        },
        {
            path: '/feeds',
            name: 'feeds',
            component: FeedsPage
        },
        {
            path: '/feeds/:feed',
            name: 'feeds',
            component: FeedsPage
        },
        {
            path: '/learn',
            name: 'learn',
            component: Learn
        },
        {
            path: '/register',
            name: 'register',
            component: Authentication
        },
        {
            path: '/login',
            name: 'login',
            component: Authentication
        },
    ]
})